import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO25 = () => {

  return (
    <StaticImage
      src="../../images/JPG-MALE-LOOK002-5.jpg"
      
      alt="Reserved avatar"
    />
  )
}

export default ImageMO25
